import React, {
	useEffect,
	useState,
	useRef,
} from 'react';

import Slider from 'react-slick';

type SealPartGalleryProps = {
	altText?: string;
	imageUrls: string[];
	pdfUrl?: string | undefined;
};

const SealPartGallery: React.FC<SealPartGalleryProps> = ({ imageUrls, altText, pdfUrl }) => {
	const [ mainSlider, setMainSlider ] = useState<Slider | null>(null);
	const [ thumbnailSlider, setThumbnailSlider ] = useState<Slider | null>(null);
	const thumbnailSliderRef = useRef<Slider | null>(null);
	const mainSliderRef = useRef<Slider | null>(null);
	const [ pdfLoading, setPdfLoading ] = useState<boolean>(true);

	const thumbnailSliderSettings = {
		slidesToShow: 3,
		infinite: false,
		swipeToSlide: true,
		focusOnSelect: true,
		asNavFor: mainSlider,
		className: 't-part-gallery__slider t-part-gallery__slider--thumbnails',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	};

	useEffect(() => {
		setMainSlider(mainSliderRef.current);
		setThumbnailSlider(thumbnailSliderRef.current);
	}, []);

	const galleryClickHandler = (event) => {
		event.preventDefault();
		event.stopPropagation();
		const currentIndex = mainSlider?.innerSlider?.state.currentSlide;
		const currentSlide = mainSlider?.innerSlider?.list?.querySelectorAll('.slick-slide')[ currentIndex || 0 ];
		if (currentSlide?.querySelector('.t-part-gallery__slide__image--pdf')) {
			window.open(pdfUrl, '_blank', 'noreferrer');
		}
	};
	const buildPdfElement = (isThumbnailGallery = false) => {
		return (
			<iframe onLoad={() => {
				setPdfLoading(false);
			}} className='t-parts-details__gallery-embed-object-container t-part-gallery__slide__image t-part-gallery__slide__image--pdf t-part-gallery_slider__image--pdf-seal' title='Seal PDF' key={'gallery-pdf-slide-1'} src={`${ pdfUrl }#toolbar=0&view=FitBV'`}></iframe>
		);
	};

	const buildSlideItems = (urls: string[], isThumbnailGallery = false): React.ReactElement[] => {
		if ((! urls || urls.length === 0) && ! pdfUrl) {
			return [
				<h4 className='t-part-gallery--empty' key="gallery-empty">No images available.</h4>,
			];
		}
		let imageSlides: JSX.Element[] = [];
		if (urls && urls.length) {
			imageSlides = urls.map((url, index) => (
				<img
					key={`gallery-slide-${ index }`}
					src={url}
					alt={`Image ${ index + 1 } ${ altText !== '' ? `for ${ altText }` : '' }`}
					className="t-part-gallery__slide__image"
					onError={(event) => (event.target as HTMLImageElement).classList.add('hidden')}
				/>
			));
		}
		return [ ...imageSlides, ...[ buildPdfElement(isThumbnailGallery) ] ];
	};

	return (
		<div className={`t-part-gallery__container slider-container ${ pdfLoading ? 't-full-block-skeleton' : '' }`}>
			<a href="#" onClick={galleryClickHandler} target='_blank' rel='noreferrer'>
				<Slider
					arrows={false}
					asNavFor={thumbnailSlider}
					ref={mainSliderRef}
					infinite={false}
					swipeToSlide={false}
					draggable={false}
					className="t-part-gallery__slider t-part-gallery__slider--main">
					{buildSlideItems(imageUrls)}
				</Slider>
			</a>
			{(imageUrls.length > 1 || (imageUrls.length >= 1 && pdfUrl)) && (
				<Slider
					{...thumbnailSliderSettings}
					ref={thumbnailSliderRef}
					className="t-part-gallery__slider t-part-gallery__slider--thumbnails"
				>
					{buildSlideItems(imageUrls, true)}
				</Slider>
			)}

		</div>
	);
};

export default SealPartGallery;
